import { ProductV2 } from '@common'

import { BrawlItem } from './BrawlItem'
import { BrawlStarsHero } from './BrawlStarsHero'

import styles from './BrawlStarsOfferCardContent.module.scss'

type Props = {
  product: ProductV2
}

export function BrawlStarsOfferCardContent({ product }: Props) {
  const isSingleItemOffer = product.contents.length === 1
  const containerStyling = isSingleItemOffer ? styles.SingleItemContainer : styles.MultiItemGridContainer
  return (
    <div className={styles.Content}>
      {!isSingleItemOffer && <BrawlStarsHero product={product} />}
      <div className={containerStyling}>
        <div className={styles.Items}>
          {product.contents.map((content, index) => (
            <div className={styles.Item} key={`product-${product.id}-content-${index}`}>
              <BrawlItem content={content} singleItemOffer={isSingleItemOffer} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
